import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
const CardComponent = ({ title, actions, onClick,children, hasContentBg, sx = {} }) => {
  return (
    <Card
    onClick={onClick}
      sx={{
        width: "100%",
        "&.MuiPaper-root": { boxShadow: "0 0 10px #ccc" },
        ".MuiCardHeader-action": { mr: 0 },
        ...sx,
      }}
    >
      {(actions || title) && (
        <CardHeader
          title={title}
          action={actions}
          sx={{
            ".MuiCardHeader-content .MuiTypography-root": {
              fontSize: "1rem",
              fontWeight: "bold",
            },
          }}
        />
      )}
      {children && (
        <CardContent
          sx={{
            ...(hasContentBg ? { backgroundColor: "#FAFAFA" } : { pt: 0 }),
          }}
        >
          {children}
        </CardContent>
      )}
    </Card>
  );
};
export default CardComponent;
